import React from "react";
import Logo from "./Logo";
import { Link } from "react-router-dom";

function Hero() {
  return (
    <section className="p-4 flex flex-col justify-center items-center min-h-lgg bg-secondary">
      <Logo width="9.5"/>
      <hgroup className="text-center mt-12 xl:w-1/2">
        <h1 className="font-bold text-3xl mb-5">رسالتنا تغيير ثقافة الصحافة العربية</h1>
        <h2 className="font-semibold text-black text-xl">
          شكّلت العقود الماضية صورةً باهتة مظلمة لدى المواطن العربي عن “مفهوم
          الصحافة”. نعتقد في ثمانية أنّ الصحافة تساهم في بناء الأوطان، وتزيد من
          المعرفة للإنسان. نؤمن أنّ المواطن العربي ينقصه الوصول إلى المعرفة التي
          هي كل ما يحتاجه الإنسان لاتخاذ قرارات تحسّن جودة حياته، وتعزز من
          مساهمته في ازدهار مجتمعه ووطنه
        .
        </h2>
        <Link to={""} className="text-primary font-extrabold mt-6 text-xl inline-block">اقرأ المزيد</Link>
      </hgroup>
      
    </section>
  );
}

export default Hero;
